import { useAuth } from "@clerk/nextjs";
import { BaseProps } from "./base";
import { apiBaseUrl, fetchWrapper } from "~/utils/utils";
import { Broadcast } from "~/lib/drizzle/type";
import { useMutation } from "@tanstack/react-query";


export const useCreateBroadcast = (props: BaseProps) => {
    const { onSuccess, onError } = props;
    const { getToken } = useAuth();

    const mutationFn = async (payload: CreateBroadcastPayload): Promise<Broadcast> => {
        const token = await getToken();
        const result = await fetchWrapper<Broadcast>({
            url: `${apiBaseUrl}/broadcasts`,
            method: 'POST',
            token,
            body: payload,
            throwOnError: true,
            showToast: true,
            showErrorToast: true,
        });

        if (!result) {
            throw new Error('Failed to create broadcast');
        }

        return result;
    };

    return useMutation({
        mutationFn,
        onSuccess: async (data, variables) => {
            onSuccess?.(data, variables);
        },
        onError
    })
}

interface CreateBroadcastPayload {
    message?: string;
    attachments?: string[];
    chat_account_id: string;
    chat_connector_type: string;
    scheduled_at: Date;
    broadcast_messages: {
        chat_provider_id: string;
        chat_connector_id: string;
    }[];
}